export default __webpack_public_path__ + "static/media/internetexplorer.3479d6bf.svg";